import React, { createContext, useContext, useEffect } from 'react';
import { useMessageStore, messageStore } from '../store/message';
import { notification } from 'antd';

const MessageContext = createContext();

const MessageProvider = ({ children }) => {
  const { websiteMessage } = useMessageStore();
  const message = useMessageStore();
  const key = 'citylife_message';

  useEffect(() => {
    if (websiteMessage) {
      notification.open({
        key,
        message: 'Authentication',
        description: websiteMessage,
        duration: 0,
        role: 'alert',
        placement: 'topRight',
        type: 'error',
        maxCount: 1,
        zIndexPopup: 999999,
        style: {
          borderRadius: '0.5rem',
        },
        onClick: () => {
          message.resetMessage();
          notification.destroy();
        },
        onClose: () => {
          message.resetMessage();
          notification.destroy();
        }
      });
    }
  }, [websiteMessage]);


  const resetMessage = () => {
    message.resetMessage();
  };

  return (
    <MessageContext.Provider value={{ resetMessage }}>
      {children}
    </MessageContext.Provider>
  );
};

const useMessage = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error('useMessage must be used within a MessageProvider');
  }
  return context;
};

export { MessageProvider, useMessage };
